/* eslint-disable no-console */

// Form direction forward trigger
// ----------------------------------------------------------------

import $ from 'jquery';
import { inputValidationOnClick } from './input-validation-on-click';
import { validationContinue } from './validation-continue';
import { stepContinue } from './step-continue';

// import { updateTriggerOnClickFunctionalityWithPlausibleProps } from './handle-updating-donation-form-trigger-with-plausible-props';

const directionForwardTrigger = $('.js-formDirectionForwardTrigger');

$(directionForwardTrigger).on('click', function() {
    var fieldset = $(this).closest('fieldset');

    inputValidationOnClick(fieldset);
    var stepValid = validationContinue(fieldset);

    // updateTriggerOnClickFunctionalityWithPlausibleProps();

    // Allows hiding/showing/scrolling if is not the submit button
    if (!$(this).hasClass('js-formDirectionSubmitTrigger')) {
        stepContinue(fieldset, stepValid);
    }
});
